import {initializeApp} from "@firebase/app"
import {getAuth, GoogleAuthProvider} from "@firebase/auth"
import {getFirestore} from "@firebase/firestore"
import {firebaseConfig} from "./firebase.config"

export const FirebaseApp = initializeApp(firebaseConfig)
export const Firestore = getFirestore(FirebaseApp)
export const auth = getAuth()
export const Providers = {google: new GoogleAuthProvider()}
